export const normalizeNumber = (
  value: number | string | null | undefined
): number | null => {
  if (value === '' || value === null || value === undefined) {
    return null
  }

  const parsed = Number(value)
  return Number.isNaN(parsed) ? null : parsed
}

export const normalizeNumberList = (
  value: Array<number | string> | string | null | undefined
): number[] => {
  if (!value) {
    return []
  }

  const values = Array.isArray(value)
    ? value
    : value.split(/[\s,]+/).filter(Boolean)

  return values
    .map((entry) =>
      normalizeNumber(typeof entry === 'string' ? entry.trim() : entry)
    )
    .filter((entry): entry is number => entry !== null)
}
